import { dsClass } from '../../common/constants/dsClasses.js';
import { allCallsAreRecordedMsg, t } from '../../common/i18n/index.js';
import { ActionBlock } from '../../content-blocks/ActionBlock/ActionBlock.js';
import { DialogWrapper } from '../DialogWrapper/index.js';

export interface ChangeNettiLiteSubscriptionDialogDispatchers {
  onCloseDialog: () => void;
  isLiikkuvaWifiSubscription?: boolean;
}

export type ChangeNettiLiteSubscriptionDialogProps = ChangeNettiLiteSubscriptionDialogDispatchers;

export const ChangeNettiLiteSubscriptionDialog = ({
  onCloseDialog,
  isLiikkuvaWifiSubscription,
}: ChangeNettiLiteSubscriptionDialogProps) => {
  const headerText = isLiikkuvaWifiSubscription
    ? t.GQLC('If you wish to change the speed of your subscription, you can contact to our sales service')
    : t.IRUO(
        'If you wish to change the data rates of your Netti Lite subscription, you can contact to our sales service'
      );

  return (
    <DialogWrapper closeable onCloseDialog={onCloseDialog}>
      <h4 className={dsClass.TEXT_ALIGN_CENTER}>{headerText}</h4>
      <ActionBlock
        additionalInformation={`${t.LJ4Y(
          'Our sales service is reachable during weekdays in hours between 8-16.00.'
        )} ${t.SCDP(allCallsAreRecordedMsg)}`}
        additionalInformationLink="https://elisa.fi/tietosuoja"
        id="sales-service"
        label="0800 04411"
        title={t.JXQZ('Sales service')}
        type="call"
      />
      <ActionBlock
        additionalInformation="https://www.yrityksille.elisa.fi/yhteydenotto"
        id="contact-request"
        label={t.D030('Leave a contact request')}
        title={t.N8JO('Or leave a contact request')}
        type="contact"
      />
    </DialogWrapper>
  );
};
